// @flow

import type {TreeStructure} from '../typedef';

type MapChildrenToParent = (children: TreeStructure, parentIds?: Array<string>) => { [key: string]: Array<string> };

export const mapChildrenToParent: MapChildrenToParent = (children, parentIds = []) => {
    return children.reduce((acc, child) => {
        if (child.children) {
            return {
                ...acc,
                [child.id]: parentIds,
                ...mapChildrenToParent(child.children, parentIds.concat(child.id))
            };
        }
        return {
            ...acc,
            [child.id]: parentIds
        };
    }, {});
};
